import {h, Component} from "preact";
import styles from "./style.scss";
import stylesReset from "./style-reset.scss";
import SectionContainer from "../section-container";
import OrganigrammaAppList from "../../sections/apps/app-list";
import Spinner from "../../common/spinner";
import {fetch as Fetch} from "whatwg-fetch";
import ConfigService from "../../../services/ConfigService";
import {TranslateService} from "../../../services/TranslateService";
import UserMenu from "../../sections/personal-area/user-menu";
import ToolbarButton from "../../common/toolbar-button";
import ModuleInfoProvider from "../../../services/ModuleInfoProvider";

//date library
import dayjs from "dayjs";
import RelativeTime from "dayjs/plugin/relativeTime";
import 'dayjs/locale/it';
dayjs.extend(RelativeTime);

export default class GlobalContainer extends Component {
    constructor(props) {
        super(props);
        this.setState({
            loading: true,
            error: false,
            hidden: false
        })
    }

    static defaultProps = {
        startHidden: false,
        config: '',

        /**
         * props.config example
         * {
            // context
            currentAppKey: 'extranet',
            organigrammaServerUrl: 'http://organigramma-server.test',
            cdnConfiguration: {},
            navigateFunction: (url) => window.location = url
            manuals: [
                {
                    title: {
                        it: 'titolo manuale'
                    },
                    url: 'example.com'
                }
            ],
            helpdeskUrl: ''
            homePageUrl: ''

            // authentication
            jwt: '',
            refreshToken: '',
            logoutRedirectUrl: '/',
            logoutCallback: () => {},

            // localization
            currentLanguage: 'it',
            availableLanguages: ['it', 'en', 'es'],
            setCurrentLanguage: () => {},
        }
         *
         */
    };

    componentDidMount() {
        this.registerGlobal();
        if (this.props.startHidden === 'true') this.stop();
        else this.start();
    }

    start = () => {
        this.setState({
            loading: true,
            error: false,
            hidden: false
        });
        this.setPropConfiguration();
        this.fetchConfiguration();
    };

    stop = () => {
        this.setState({hidden: true});
    };

    render(props) {
        const loadingSpinner = () => <SectionContainer><Spinner/></SectionContainer>;

        const errorSection = () =>
            <SectionContainer>
                <div class={styles.errorAlert}>{TranslateService.t("configuration.loading.error")}</div>
                <ToolbarButton onClick={this.fetchConfiguration}>{TranslateService.t("action.retry")}</ToolbarButton>
            </SectionContainer>
        ;

        const currentApp = ConfigService.modules().find(m => m.key === ConfigService.currentAppKey());
        const sections = () => this.state.hidden ? [] : [
            <SectionContainer style={{justifyContent: 'flex-start', flexGrow: 2}}>
                <OrganigrammaAppList currentApp={currentApp} apps={ConfigService.modules()}/>
            </SectionContainer>
            ,
            <SectionContainer style={{justifyContent: 'flex-end', flexGrow: 1}}>
                <UserMenu organigrammaServerUrl={ConfigService.organigrammaServerUrl()}/>
            </SectionContainer>
        ];

        const barClasses = [
            stylesReset.clean,
            this.state.hidden ? ' hidden-bar' : null
        ].filter(i => i).join(' ');

        return (
            <div class={barClasses} style={{display: this.state.hidden ? 'none' : 'block'}}>
                <div class={styles.globalContainer}>
                    <div class={styles.mainToolbar}>
                        {!this.state.error && !this.state.loading && sections().map(i => i)}
                        {!this.state.error && this.state.loading && loadingSpinner()}
                        {this.state.error && errorSection()}
                    </div>
                    <DefaultPortal />
                </div>
            </div>
        );
    };

    registerGlobal() {
        window.dpaGlobalTopBar = {
            stop: this.stop,
            start: this.start,
            getState: () => Object.assign({}, this.state),
            update: this.setPropConfiguration,
        };
    }

    setPropConfiguration = () => {
        const config = this.getFromPath(window, this.props.config);

        ConfigService.currentAppKey(config.currentAppKey);
        ConfigService.organigrammaServerUrl(config.organigrammaServerUrl);
        ConfigService.cdnConfiguration(config.cdnConfiguration);
        ConfigService.navigateFunction = config.navigateFunction;
        ConfigService.manuals(config.manuals);
        ConfigService.helpdeskUrl(config.helpdeskUrl);
        ConfigService.homepageUrl(config.homepageUrl);
        if (config.iconBaseUrl) ConfigService.iconBaseUrl(config.iconBaseUrl);

        ConfigService.jwt(config.jwt);
        ConfigService.refreshToken(config.refreshToken);
        ConfigService.logoutRedirectUrl(config.logoutRedirectUrl);
        ConfigService.logoutCallback = config.logoutCallback;
        ConfigService.authFailureCallback = config.authFailureCallback;

        ConfigService.currentLanguage(config.currentLanguage);
        ConfigService.availableLanguages(config.availableLanguages);
        ConfigService.setCurrentLanguage = config.setCurrentLanguage;
    };

    fetchConfiguration = () => {
        this.setState({loading: true, error: false});
        Fetch(ConfigService.organigrammaServerUrl() + '/configuration')
            .then(res => res.json())
            .then(res => {
                ConfigService.modules(ModuleInfoProvider.createFlatModuleArray(res.data.modules));
                ConfigService.localization(res.data.localization);
                this.setState({loading: false});
            })
            .catch(() => this.setState({error: true}))
        ;
    };

    getFromPath(base, path) {
        if (!path.length) return () => {};
        let object = base;
        path.split('.').forEach(p => object = object[p]);
        return object;
    }
}

class DefaultPortal extends Component {
    shouldComponentUpdate = () => false;

    render(props, state, context) {
        return (
            <div
                id={'dpa-global-top-bar-additional-toolbar'}
                className={[styles.mainToolbar, styles.additionalToolbar].join(' ')}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./components/layout/global-container/index.js